import { ActionTypes } from '../constants/index';

export const getPaymentInfo = (payload: any) => ({
  type: ActionTypes.PAYMENT_MANAGEMENT_INFO_LIST_REQUEST,
  payload,
});
